<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <NanLoading v-if="isLoading" />

      <template v-else>
        <b-alert :show="!!error" variant="danger">{{ error }}</b-alert>

        <b-alert :show="!!isRedirecting" variant="success"
          >Success! Redirecting...</b-alert
        >
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import API from "@/api";

export default {
  metaInfo: {
    titleTemplate: "Claim License - %s"
  },

  data: () => ({
    isLoading: false,
    isRedirecting: false,
    error: null
  }),

  computed: {
    ...mapState(["token"])
  },

  async created() {
    const sharerToken = this.$route.query.token || null;
    const receiverToken = this.token ? this.token.value : null;

    if (!sharerToken) {
      return this.$router.push({ name: "404" });
    }

    if (!receiverToken) {
      return this.$router.push({
        name: "Login",
        query: { goto: "/claim", ...this.$route.query }
      });
    }

    try {
      this.isLoading = true;

      const res = await API.claimLicense({ sharerToken, receiverToken });

      if (res.success) {
        this.isRedirecting = true;

        setTimeout(() => {
          this.$router.push("/");
        }, 1500);
      }
    } catch (err) {
      console.warn(err);
      this.error = "There was an error claiming the license";
    } finally {
      this.isLoading = false;
    }
  }
};
</script>
